<template>
  <div
    class="post-options dropdown-container"
    v-if="options"
    @mouseleave="showOptions = false"
  >
    <div class="dropdown-fake-container" :class="{ active: showOptions }">
      <i
        class="dropdown-btn fa-lg fas icon"
        :class="{ active: showOptions }"
        aria-hidden="true"
        @click="showOptions = !showOptions"
      >
      </i>
    </div>
    <div v-if="showOptions" class="dropdown-items">
      <div class="item" @click="showOptionReport = !showOptionReport">
        {{ $t("report.title") }}
      </div>
    </div>
  </div>
  <PostOptionsModalReport
    v-if="showOptionReport"
    @cancel="showOptionReport = false"
    :modelId="modelId"
    :postId="postId"
  />
</template>

<script setup lang="ts">
const { options, modelId, postId } = withDefaults(
  defineProps<{
    options?: boolean;
    modelId: string | number;
    postId: string | number;
  }>(),
  {
    options: true,
  }
);

if (!modelId || !postId) {
  throw new Error("modelId or postId is missing");
}

const showOptions = ref(false);
const showOptionReport = ref(false);
</script>

<style scoped lang="scss">
.post-options {
  align-self: center;
  .icon {
    width: 20px;
    height: 20px;
    padding-bottom: 0.75em;
    // padding-inline: 0.5em;
    background-image: url("/img/btn/three-dots.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
}

.dropdown-container {
  position: absolute;
  margin-inline: 0px;
  right: 0%;

  .item,
  .dropdown-fake-container.active {
    min-width: 150px;
    text-align: center;
    color: inherit;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    padding-block: 0.75em;
    flex-grow: 1;
    transition: background-color 0.2s ease-in-out;

    &.router-link-active {
      background-color: lighten(#000000, 60);
    }

    &:hover {
      background-color: lighten(#000000, 75);
    }
  }

  .item {
    display: block;
  }

  .dropdown-fake-container {
    display: flex;
    justify-content: end;

    &.active {
      padding-block: 0em;
      background-color: unset !important;
    }
  }

  .dropdown-btn {
    cursor: pointer;

    &.active {
      cursor: default;
    }
  }

  .dropdown-items {
    position: absolute;
    top: 100%;
    right: 0%;
    z-index: 9;
    background: lighten(#000000, 90);
  }
}
</style>
